<template>
    <AppChartWrapper
            :hideIcon="true"
            imageName="Reaction Cloud">
        <h4 slot="title" class="subheading text-xs-left font-weight-regular section-title--color">
            Reaction Cloud
        </h4>
        <template v-slot:chart v-if="summaryReady">
            <vue-word-cloud
                    :color="word => {
                                            return {
                                              like: '#558DFD',
                                              love: '#FF009D',
                                              haha: '#F9C02F',
                                              sad: '#32C5FF',
                                              wow: '#000000',
                                              angry: '#FF0100',
                                            }[word.category]
                                          }"
                    :words="reactionData"
                    font-family="Noto Emoji"
                    style="min-width: 100px; min-height: 301px; margin-top: -25px;"
                    v-if="reactionData.length > 0"
            ></vue-word-cloud>
            <div class="text-xs-center d-flex fill-height align-center" style="height: 325px"
                 v-else>
                            <span class="font-weight-bold display-1"
                                  style="color:#AFBAC8">No Reaction Data</span>
            </div>
        </template>
    </AppChartWrapper>
</template>

<script>
	import VueWordCloud from "vuewordcloud";
	import {mapState} from 'vuex';
    import downloadChart from "@/mixins/downloadChart";
	import AppChartWrapper from "../AppChartWrapper";
	export default {
		components: {
			AppChartWrapper,
			[VueWordCloud.name]: VueWordCloud
		},
        mixins:[downloadChart],
		data() {
			return {
				range: [900, 750, 600, 450, 300, 150, 100, 50],
				reactions: {like: "👍", love: "❤️", angry: "😠", haha: "😂", sad: "😢", wow: "😮"}
			}
		},
		computed: {
			...mapState([
				'facebookSummary'
			]),

			...mapState('mention', [
				'summaryReady'
			]),

			reactionCount() {
				return this.facebookSummary.reactions.count;
			},

			reactionData() {
                let sortedReaction = Object.entries(this.reactionCount).sort((a, b) => b[1] - a[1]);
				let total = Object.values(this.reactionCount).reduce((acc,cur) => acc+cur, 0);
				return sortedReaction.map((item, index, array) => {
					if (item[1] === 0) return undefined;
					let text = item[0].split("_")[1];
					// let maxFontWeight = 40;
                    let maxFontWeight = 30;
					let weight = Math.floor((item[1]/total) * maxFontWeight);
					let logValue = Math.floor(Math.log(item[1]));
					weight = weight === 0 ? logValue : weight+logValue;
					weight = weight > maxFontWeight ? maxFontWeight : weight;
					return {
						category: text,
						text: this.reactions[text],
                        weight
					}
				}).filter(item => !!item);
			}
		}
	}
</script>

<style scoped>
    @font-face{
        font-family: "Noto Emoji";
        src: url("../../../public/fonts/NotoColorEmoji.ttf")
        format("truetype");
    }
</style>
